import React from 'react';
import { useIntl } from 'react-intl';

import { useCurrentTheme } from 'app/shared/theme';
import { ActionLink, Box, Icon, Typography } from 'app/shared/components/atoms';
import { ReactComponent as Mail } from 'icons/mail.svg';

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}
export const NotifyMe: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
}) => {
  const { formatMessage } = useIntl();
  const { colors } = useCurrentTheme();

  return (
    <Box flexDirection="column" gap={1}>
      <Typography color={colors.primary.white.base} fontWeight="semibold">
        {formatMessage({ id: 'eventCollectionFollow.intro' })}
      </Typography>
      <ActionLink
        onClick={onClick}
        variant="primary"
        alignItems="center"
        gap={2}
        svgFillColor="none"
        lineHeight="100%"
      >
        <Icon icon={Mail} size="sm" w="auto" />
        {formatMessage({ id: 'eventCollectionFollow.notifyMe' })}
      </ActionLink>
    </Box>
  );
};
